// designTokens.js
// Single source of truth for the colors/shadows used across InsightsView
// and every Breakdown modal. Import from here instead of redefining locally.

export const BORDER = "1px solid #EDF1F5";
export const TEXT_MUTED = "#64748B";
export const TEXT_SUBTLE = "#94A3B8";
export const TEXT_HEADING = "#0F172A";
export const BRAND_BLUE = "#1565C0";
export const BRAND_BLUE_SOFT = "#EFF6FF";

export const CARD_SHADOW = "0 1px 2px rgba(15, 23, 42, 0.04)";

export const BADGE_STYLES = {
  Good: { bg: "#DCFCE7", color: "#15803D" },
  Medium: { bg: "#FEF3C7", color: "#B45309" },
  Bad: { bg: "#FEE2E2", color: "#B91C1C" },
};

// Palette used for avatar chips in tables (Cardiology, Neurology, ...)
export const AVATAR_PALETTE = [
  { bg: "#DBEAFE", color: "#1D4ED8" }, // blue
  { bg: "#EDE9FE", color: "#6D28D9" }, // violet
  { bg: "#DCFCE7", color: "#15803D" }, // green
  { bg: "#FFE4E6", color: "#BE123C" }, // rose
  { bg: "#FEF3C7", color: "#B45309" }, // amber
  { bg: "#CFFAFE", color: "#0E7490" }, // cyan
];

export const CHART_DATE_LABELS = ["May 01", "May 08", "May 15", "May 22", "May 31"];
export const CHART_LABELS_10PT = [
  "May 01", "May 04", "May 08", "May 11", "May 15",
  "May 18", "May 22", "May 25", "May 29", "May 31",
];

export function formatYTick(value) {
  if (Math.abs(value) >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 1_000) return `$${(value / 1_000).toFixed(1)}K`;
  return `$${value}`;
}

export function niceCeil(max) {
  if (max <= 0) return 1;
  const magnitude = Math.pow(10, Math.floor(Math.log10(max)));
  const normalized = max / magnitude;
  let niceNormalized;
  if (normalized <= 1) niceNormalized = 1;
  else if (normalized <= 2.5) niceNormalized = 2.5;
  else if (normalized <= 5) niceNormalized = 5;
  else niceNormalized = 10;
  return niceNormalized * magnitude;
}
export function formatRelativeTime(isoString) {
  if (!isoString) return "—";
  const then = new Date(isoString).getTime();
  const diffMs = Date.now() - then;
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 10) return "Just now";
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min${diffMin === 1 ? "" : "s"} ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? "" : "s"} ago`;
  const diffDay = Math.floor(diffHr / 24);
  return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
}